import type { HttpClient } from '@shared/http/http-client';
import type {
  IProductionPartnerRepository,
  ProductionPartnerListQuery,
} from '@domain/data-contracts/production-partner-repository.interface';
import type { ProductionPartner } from '@domain/models/production-partner.interface';
import type { PagedResult } from '@domain/models/paging.interface';
import {
  mapProductionPartnerDto,
  mapPaged,
  type ProductionPartnerDto,
  type PagedDto,
} from './mapping.helper';

const BASE = '/api/partners';

export class ProductionPartnerRepository implements IProductionPartnerRepository {
  public constructor(private readonly http: HttpClient) {}

  public async list(query: ProductionPartnerListQuery): Promise<PagedResult<ProductionPartner>> {
    const response = await this.http.get<PagedDto<ProductionPartnerDto>>(BASE, {
      params: pruneParams(query),
    });
    return mapPaged(response.data, mapProductionPartnerDto);
  }
}

function pruneParams(query: ProductionPartnerListQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (query.search && query.search.trim().length > 0) { out.search = query.search.trim(); }
  if (typeof query.page === 'number') { out.page = query.page; }
  if (typeof query.pageSize === 'number') { out.pageSize = query.pageSize; }
  return out;
}
